@import 'styles/mixins';
@import 'styles/variables';

.scimSettings {
  margin-top: 32px;
}

.helpText {
  @include md-regular;

  color: $grey-40;
  margin-top: 8px;
  width: 75%;
}

.reachOutText {
  @include md-regular;
  color: var(--neutral-40);
  margin-bottom: 12px;
}
